import Autocomplete from "@mui/material/Autocomplete"
import TextField from "@mui/material/TextField";
import { debounce } from "lodash";
import { Option } from "../../../pages/manualDishes/useSelectDish.hooks";
import React from "react";


type Obj = {
  [x: string]: any
};

type SelectProps<T extends Obj>  = {
  options: Option[]
  handleSearch: (inputVal: any) => Promise<void>
  handleSelect: (event: React.SyntheticEvent<Element, Event>, selectedVal: any) => void
  isLoading?: boolean
  selectedVal?: Option,
  label?: string,
  width?: number,
  placeholder?: string
}

// using lodash
export const SelectIncrementalSearch = <T extends Obj> (props: SelectProps<T>) => {
  const { options, selectedVal, handleSearch, handleSelect, isLoading=false, label='', width=200, placeholder="商品名・コードで検索する"} = props;

  const term = 750;
  const handleDebounceSearch = debounce((changeValue: any) => 
    handleSearch(changeValue),
    term
  );

  return (
    <Autocomplete
      key={selectedVal?.label ?? null} // 入力後、値をリセットするときは設定する
      fullWidth
      options={options}
      loading={isLoading}
      onInputChange={(e, changeValue) => {
        handleDebounceSearch(changeValue);
      }}
      onChange={handleSelect}
      filterOptions={(options) => options}
      isOptionEqualToValue={(option, v) =>
        option.label === v.label
      }
      renderInput={(params) => 
        <TextField
          {...params} 
          label={label}
          placeholder={placeholder}
        />
      }
      sx={{ width: width }}
    />
  );
};
